<template>
    <div>
        <CCard>
            <CCardHeader>
                PruebaTarheta2
            </CCardHeader>
            <CCardBody>
                <CRow>
                    <CCol col="3">
                        <multiselect class="m-0 d-inline-block mb-2" 
                            v-model="clienteSelected"
                            deselect-label="" 
                            label="nombreCliente" 
                            placeholder="Cliente" 
                            select-label=""
                            selectedLabel=""
                            :options="clientesData" 
                            :searchable="true"
                            @select="seleccionarCliente"
                        >
                        </multiselect>
                
                    </CCol>
                </CRow>
                <CRow>
                    <CCol col="3">
                       <CButton 
                            style="width: 100%;"
                            class="btnPrincipalVapp"
                            size="md" >
                            <CIcon :content="$options.freeSet.cilLoopCircular" /> Actualizar BD
                        </CButton>
                    </CCol>
                    <CCol col="3">
                       <CButton 
                            style="width: 100%;"
                            class="btnPrincipalVapp"
                            size="md" >
                            <CIcon :content="$options.freeSet.cilLoopCircular" /> Actualizar Documentos
                        </CButton>
                    </CCol>
                    <CCol col="3">
                       <CButton 
                            style="width: 100%;"
                            class="btnPrincipalVapp"
                            size="md" >
                            <CIcon :content="$options.freeSet.cilLoopCircular" /> Actualizar Trabajadores
                        </CButton>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol col="12">
                    </CCol>
                </CRow>
            </CCardBody>
        <CCardFooter></CCardFooter>
    </CCard>
        
    </div>
</template>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import cons from "@/const";
    import axios from "axios";
    import Multiselect from "vue-multiselect";
    import qs from "qs";

    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";

    import { freeSet } from "@coreui/icons";


    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    export default {
        name: "ConfiguracionCliente",
        freeSet,
        components: {
            Multiselect,
            Modal: VueModal
        },

        data() {
            return {
                baseUrl: cons.protocolo+"://" + cons.ipServer + cons.puerto,
                //tokenLogin: JSON.parse(this.$cookie.get("userLogginToken")).tokenUsuario,

                regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                clienteSelected: null,
                clientesData: [],

            };
        },
        beforeMount() {
            //alert(this.cliente);
            this.getClientes()
            //console.log(this.$route.params.cliente)

            if(this.clienteSelected == null){
                this.clienteSelected = this.$route.params.cliente
                this.seleccionarCliente(this.clienteSelected)
            }

        },

        methods: {
            getClientes: function(){
                var url = this.baseUrl + "/get_clientes_vapp";

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.clientesData = result.data;
                    
                }, error => {
                        let mensaje = `Problema al obtener Clientes, ${error}`
                })
                .finally(() => {
                });
            },
            seleccionarCliente: function(cliente){
                console.log("asdasdasd", cliente)
            }
        },
    };
</script>

<style scoped>
.form-group{
  margin-top: 1rem;
  margin-bottom: 0;
}
.form-row{
  width: 80%;
}
</style>